import { apiUrl as configApiUrl } from '../config';

let config = {};

export const initializeConfig = (secrets) => {
  config = {};
};

export const getConfig = () => config;
export const apiUrl = configApiUrl;

export const GeneratedTitle = "generated_title";
export const SummaryTitle = "summary_title";
export const ScreenSize = 150000; // Support ~30K words for system instructions
export const TextLimit = 100000;

export const STATUS = {
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

export const IMAGE_NOT_ALLOWED_FOR = {
  // Anthropic: true,
  Anthropic: false,
};

// Re-export imageExtensions from fileConstants for backward compatibility
export { imageExtensions } from "./fileConstants";

// =============================================================================
// REACT QUERY CACHE DURATIONS
// Centralised here so tuning decisions are visible in one place.
// All values are in milliseconds.
// =============================================================================
export {
  CACHE_FOREVER,
  GC_7DAYS,
  STALE_30S,
  STALE_48H,
  STALE_5MIN,
  STALE_NEVER,
} from '@photon/chat-core';
